<template>
  <div class="page-content">
    <!-- 动态加载对应模块页面 -->
    <component :is="currentPage" v-if="currentPage" />
    
    <!-- 占位提示（开发中） -->
    <div v-else class="placeholder-page">
      <div class="placeholder-icon">🚧</div>
      <div class="placeholder-text">页面开发中...</div>
    </div>
  </div>
</template>

<script>
// 这里后续会引入各个模块页面
import CrmDashboard from '../pages/CrmDashboard.vue'
import CrmSales from '../pages/CrmSales.vue'
import CrmMarketing from '../pages/CrmMarketing.vue'
import CrmService from '../pages/CrmService.vue'
import CrmAnalytics from '../pages/CrmAnalytics.vue'

export default {
  name: 'PageContent',
  components: {
    CrmDashboard,
    CrmSales,
    CrmMarketing,
    CrmService,
    CrmAnalytics,
  },
  props: {
    activeModule: {
      type: String,
      default: 'CrmDashboard'
    }
  },
  watch: {
    activeModule(newPages) {
      this.currentPage = newPages;
    }
  },
  data() {
    return {
      currentPage: "CrmDashboard"
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  flex: 1;
  height: 100%;
  overflow: hidden;
  background: #0a1f0f;
  position: relative;
}

.placeholder-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #4CAF50;

  .placeholder-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  .placeholder-text {
    font-size: 16px;
    opacity: 0.6;
    letter-spacing: 2px;
  }
}
</style>